// Generated by scripts/build-metro-hubs.js. Area labels are hand-written; room names and addresses come from the seed. Do not hand-edit.
module.exports = {
  "houston-poker-rooms": {
    "cardRooms": {
      "h": "How Houston card rooms work",
      "p": [
        "Texas law does not let a house take a cut of the pot, so Houston poker rooms run as private social clubs. Instead of raking pots, they charge a membership and a seat or time fee, and that fee is separate from the tournament buy-ins listed here.",
        "Membership terms differ by club, so check with the room before your first visit. Each room page lists the phone number and website we have on file."
      ]
    },
    "stay": {
      "h": "Hotels near Houston poker rooms: where the clubs are",
      "lead": "Houston’s card rooms are spread across the metro, from Katy in the west to Baytown in the east, so if you are booking a hotel around a tournament, pick the area by club and search near its street address. We don’t partner with or recommend any hotel.",
      "areas": [
        {
          "label": "West Houston, along Westheimer Rd and the West Sam Houston Pkwy (Beltway 8)",
          "rooms": [
            {
              "name": "Texas Card House Houston",
              "address": "6100 Westheimer Rd, Suite 142, Houston, TX 77057"
            },
            {
              "name": "Champions Club Texas",
              "address": "6440 West Sam Houston Parkway South, Houston, TX 77072"
            },
            {
              "name": "Empire Poker Club",
              "address": "2938 W Sam Houston Parkway, Houston, TX 77042"
            },
            {
              "name": "Prime Social Club",
              "address": "7801 Westheimer Rd, Houston, TX 77063"
            }
          ]
        },
        {
          "label": "Northwest Houston and Cypress, along the Northwest Fwy (US-290)",
          "rooms": [
            {
              "name": "Paramount Social Club",
              "address": "13153 Northwest Freeway, Houston, TX 77040"
            },
            {
              "name": "Doghouse Poker Club",
              "address": "27118 US-290, Suite D, Cypress, TX 77433"
            }
          ]
        },
        {
          "label": "Central Houston, inside the 610 Loop",
          "rooms": [
            {
              "name": "Lonestar Social Poker Club",
              "address": "1985 W TC Jester Blvd, Houston, TX 77008"
            }
          ]
        },
        {
          "label": "Katy, on the Katy Fwy (I-10 west)",
          "rooms": [
            {
              "name": "101 Poker Club",
              "address": "20900 Katy Fwy, Suite N-1, Katy, TX 77449"
            }
          ]
        },
        {
          "label": "North: Spring and Humble",
          "rooms": [
            {
              "name": "Texas Card House Spring",
              "address": "1411 Spring Cypress Rd, Northland Mall, Suites 109-110, Spring, TX 77373"
            },
            {
              "name": "The Hangar Poker House",
              "address": "244 First St W, Humble, TX 77338"
            }
          ]
        },
        {
          "label": "East: Baytown",
          "rooms": [
            {
              "name": "Spades Poker House Baytown",
              "address": "6952 Garth Rd, Baytown, TX 77521"
            }
          ]
        },
        {
          "label": "South: Webster, on the Gulf Fwy (I-45) near Clear Lake",
          "rooms": [
            {
              "name": "Spades Poker House Webster",
              "address": "20798 Gulf Fwy, Webster, TX 77598"
            }
          ]
        }
      ]
    }
  },
  "san-diego-poker-rooms": {
    "cardRooms": {
      "h": "How San Diego poker rooms work: casino vs. card room",
      "p": [
        "Sycuan Casino Resort is a tribal casino in El Cajon. Its smoke-free poker room is open 24 hours a day, 7 days a week, and spreads limit hold’em with a full kill, Omaha hi/lo, and no-limit hold’em from 1/3 up to 5/5/10. To get on a cash game list, call the poker room at (619) 659-3303 or use the Bravo app, per Sycuan’s poker page.",
        "Ocean’s 11 Casino in Oceanside is a California card room, not a tribal casino. It is open 24 hours, Monday through Sunday, and spreads limit and no-limit Texas hold’em and Omaha; call the floor at (760) 439-6988 for current limits and buy-ins.",
        "Jamul Casino Resort, owned by the Jamul Indian Village, posts its weekly no-limit hold’em tournaments on its poker room page, with morning events on weekdays and evening events most nights. To get on a waitlist, call the poker room at (619) 315-2270 or use the Bravo app, per Jamul’s poker page.",
        "Seven Mile Casino in Chula Vista is a card room on the bay that lists poker among its games and is open 24 hours a day, 7 days a week. It does not publish a tournament schedule, so call (619) 425-3333 for current games.",
        "If you want 24-hour poker in San Diego or a game after midnight, Sycuan, Seven Mile, and Ocean’s 11 are the rooms on file that post 24-hour hours. Barona Resort & Casino in Lakeside is also on file, but it has no tournament schedule listed."
      ]
    },
    "stay": {
      "h": "Where the San Diego poker rooms are",
      "lead": "San Diego’s poker rooms are spread from Oceanside in the north to Chula Vista in the south and Jamul and El Cajon in the east, so if you are booking a hotel around a tournament, pick the room first and search near its street address. We don’t partner with or recommend any hotel.",
      "areas": [
        {
          "label": "East County: El Cajon, off I-8 about 20 miles east of downtown",
          "rooms": [
            {
              "name": "Sycuan Casino",
              "address": "5469 Casino Way, El Cajon, CA 92019"
            }
          ]
        },
        {
          "label": "East County: Jamul, on Campo Rd",
          "rooms": [
            {
              "name": "Jamul Casino Resort",
              "address": "14145 Campo Rd, Jamul, CA 91935"
            }
          ]
        },
        {
          "label": "East County: Lakeside, no tournament schedule on file",
          "rooms": [
            {
              "name": "Barona Resort & Casino",
              "address": "1932 Wildcat Canyon Rd, Lakeside, CA 92040"
            }
          ]
        },
        {
          "label": "South Bay: Chula Vista, on Bay Blvd, no tournament schedule on file",
          "rooms": [
            {
              "name": "Seven Mile Casino",
              "address": "285 Bay Blvd, Chula Vista, CA 91910"
            }
          ]
        },
        {
          "label": "North County: downtown Oceanside, near I-5",
          "rooms": [
            {
              "name": "Ocean's 11 Casino",
              "address": "121 Brooks Street, Oceanside, CA 92054"
            }
          ]
        }
      ]
    }
  },
  "texas-poker-rooms": {
    "cardRooms": {
      "h": "How Texas poker rooms work",
      "p": [
        "Texas law does not let a house take a cut of the pot, so almost all Texas poker is played at private social clubs: Texas Card House, TCH Social, The Lodge, Shuffle, Palace Poker, Champions Club, and others. They charge a membership and a seat or time fee instead of raking pots, and that fee is separate from any tournament buy-in listed here.",
        "The one casino poker room on file in Texas is Kickapoo Lucky Eagle Casino & Hotel in Eagle Pass. Membership terms differ by club, so check with the room before your first visit; each room page lists the phone number and website we have on file."
      ]
    },
    "stay": {
      "h": "Staying near Texas card rooms",
      "lead": "Texas card rooms sit in the four big metros plus a few outliers. If you are traveling for a tournament, pick the metro, then search hotels near the club’s street address. We don’t partner with or recommend any hotel.",
      "areas": [
        {
          "label": "Houston",
          "hub": "/houston-poker-rooms",
          "rooms": [
            {
              "name": "Texas Card House Houston",
              "address": "6100 Westheimer Rd, Suite 142, Houston, TX 77057"
            },
            {
              "name": "Champions Club Texas",
              "address": "6440 West Sam Houston Parkway South, Houston, TX 77072"
            },
            {
              "name": "Empire Poker Club",
              "address": "2938 W Sam Houston Parkway, Houston, TX 77042"
            },
            {
              "name": "Prime Social Club",
              "address": "7801 Westheimer Rd, Houston, TX 77063"
            },
            {
              "name": "Paramount Social Club",
              "address": "13153 Northwest Freeway, Houston, TX 77040"
            },
            {
              "name": "Lonestar Social Poker Club",
              "address": "1985 W TC Jester Blvd, Houston, TX 77008"
            },
            {
              "name": "Doghouse Poker Club",
              "address": "27118 US-290, Suite D, Cypress, TX 77433"
            },
            {
              "name": "101 Poker Club",
              "address": "20900 Katy Fwy, Suite N-1, Katy, TX 77449"
            },
            {
              "name": "Texas Card House Spring",
              "address": "1411 Spring Cypress Rd, Northland Mall, Suites 109-110, Spring, TX 77373"
            },
            {
              "name": "The Hangar Poker House",
              "address": "244 First St W, Humble, TX 77338"
            },
            {
              "name": "Spades Poker House Baytown",
              "address": "6952 Garth Rd, Baytown, TX 77521"
            },
            {
              "name": "Spades Poker House Webster",
              "address": "20798 Gulf Fwy, Webster, TX 77598"
            }
          ]
        },
        {
          "label": "Dallas–Fort Worth",
          "hub": "/dallas-poker-rooms",
          "rooms": [
            {
              "name": "Texas Card House Dallas",
              "address": "11834 Harry Hines Blvd, Suite 135, Dallas, TX 75234"
            },
            {
              "name": "Champions Social Club",
              "address": "17776 Dallas Pkwy, Dallas, TX 75287"
            },
            {
              "name": "Shuffle 214",
              "address": "11411 E Northwest Hwy, Dallas, TX 75218"
            },
            {
              "name": "TCH Social Las Colinas",
              "address": "955 W John Carpenter Fwy, Suite 110, Irving, TX 75039"
            },
            {
              "name": "Palace Poker Texas",
              "address": "401 E Palace Pkwy, Grand Prairie, TX 75050"
            },
            {
              "name": "Poker House Fort Worth",
              "address": "1055 SW Wilshire Blvd, Suite 101, Burleson, TX 76028"
            },
            {
              "name": "The Fort Card Room",
              "address": "8420 I-20 Frontage Rd, Aledo, TX 76008"
            }
          ]
        },
        {
          "label": "Austin and Round Rock",
          "hub": "/austin-poker-rooms",
          "rooms": [
            {
              "name": "Shuffle 512",
              "address": "6501 South Congress Ave, #1-104, Austin, TX 78745"
            },
            {
              "name": "TCH Social Austin",
              "address": "13530 US-183 Hwy, Suite 100, Austin, TX 78750"
            },
            {
              "name": "The Lodge Card Club Round Rock",
              "address": "1401 S Interstate 35, Suite 130, Round Rock, TX 78664"
            }
          ]
        },
        {
          "label": "San Antonio",
          "hub": "/san-antonio-poker-rooms",
          "rooms": [
            {
              "name": "Alamo City Poker Club",
              "address": "999 E Basse Rd Suite 180, San Antonio, TX 78209"
            },
            {
              "name": "The Lodge Card Club San Antonio",
              "address": "3723 Colony Dr, Suite 101, San Antonio, TX 78230"
            },
            {
              "name": "SA Card House",
              "address": "13400 San Pedro Ave, San Antonio, TX 78216"
            }
          ]
        },
        {
          "label": "Amarillo, the Rio Grande Valley, and Eagle Pass",
          "rooms": [
            {
              "name": "Amarillo Social Club",
              "address": "1375 N Western St, Amarillo, TX 79124"
            },
            {
              "name": "Texas Card House Rio Grande Valley",
              "address": "403 W Trenton Rd, Suite 2-B, Edinburg, TX 78539"
            },
            {
              "name": "Kickapoo Lucky Eagle Casino & Hotel",
              "address": "794 Lucky Eagle Dr, Eagle Pass, TX 78852"
            }
          ]
        }
      ]
    }
  }
};



// WEBPACK FOOTER //
// ./js/hub-extras.js